import React, { useCallback, useRef } from 'react'
import { Outlet } from 'react-router'
import MenuWrapper from './menu/menu.wrapper'
import DemoHeader from '@/modules/base/components/demoHeader/demoHeader'
import clsx from 'clsx'
import { makeStyles } from '@mui/styles'
import ThemeInterface from '@/theme-interface'
import AiChatEntry from '@ai-chat-entry'
import { useAppSelector } from '@/redux/store'
import { selectAiSettingsEnabled } from '@/redux/ducks/tenantUser/settings'
import { isMeinBuero } from '@/utils/build-env'
import PostHogConsentNotice from '@/modules/posthog/components/posthog-consent-notice'
import type { AiChatDockLayout } from '@ai-chat-widget-contracts/contracts'

const isMB = isMeinBuero()

type Props = {
  noBackgroundColor?: boolean,
  showAccountOnly?: boolean
}

const useStyles = makeStyles((theme: ThemeInterface) => ({
  backgroundGrey: {
    backgroundColor: theme.backgroundColor,
  },
}))

const MenuLayout = (props: Props) => {
  const classes = useStyles()
  const { noBackgroundColor, showAccountOnly = false } = props

  const aiSettingsEnabled = useAppSelector(selectAiSettingsEnabled)
  const mainRef = useRef<HTMLElement>(null)
  const handleDockLayoutChange = useCallback(({ docked, reservedWidth, resizing }: AiChatDockLayout) => {
    if (!mainRef.current) return
    mainRef.current.style.setProperty('--ai-chat-reserved-width', `${docked ? reservedWidth : 0}px`)
    mainRef.current.style.transition = resizing ? 'none' : 'margin-right 200ms ease-out'
  }, [])

  return (
    <>
      <div>
        <div className="layout layout-nav">
          <PostHogConsentNotice />
          <div className="demoHeader">
            <DemoHeader />
          </div>
          <nav className="nav" role="navigation">
            <MenuWrapper />
          </nav>
          <main
            ref={mainRef}
            className={clsx('menuLayoutMain', !noBackgroundColor && classes.backgroundGrey)}
            id="pageContent"
            style={{ marginRight: 'var(--ai-chat-reserved-width, 0px)', transition: 'margin-right 200ms ease-out' }}
          >
            <Outlet />
          </main>
        </div>
      </div>
      {!isMB && aiSettingsEnabled && <AiChatEntry onDockLayoutChange={handleDockLayoutChange} />}
    </>
  )
}

export default MenuLayout
